import React from 'react'
import {useSelector} from 'react-redux'
import {Box, Typography} from '@mui/material'
import 'features/HomePage/TrackShipments/index.scss'

const ShipmentHeader = () => {
    const {response: AWBResponse} = useSelector((state: any) => state.trackShipment)

    return (
        <Box>
            {AWBResponse?.successFlag && (
                <Box className='page-awbNum' data-testid='awb-box'>
                    <Typography className='page-awbNum__text' component='span'>
                        AWB &nbsp;
                    </Typography>
                    <Typography className='page-awbNum__num' component='span'>
                        {AWBResponse?.airlineCode} - {AWBResponse?.awbNumber}
                    </Typography>
                </Box>
            )}
        </Box>
    )
}

export default ShipmentHeader
